export default "__VITE_ASSET__9ZB9O9kB__"